import classNames from 'classnames';
import PropTypes from 'prop-types';

interface Props {
    name: string;
    className?: string;
}

function UiSvg({ name, className }: Props) {
    const svg = require('../../../common/components/ui-svg-include/svgs/' + name + '.svg');
    const props = {
        dangerouslySetInnerHTML: {
            __html: svg,
        },
        className: classNames('react-ui-svg', className),
    };
    return <span {...props} />;
}

(UiSvg as any).propTypes = {
    name: PropTypes.string.isRequired,
};

export default UiSvg;
